export function getTextLength(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent?.length ?? 0;
}
